var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph-container"},[_c('line-chart',{attrs:{"series":_vm.series,"labels":_vm.labels,"x-axis":_vm.xAxis,"y-axis":_vm.yAxis,"colors":_vm.colors,"annotations":_vm.annotations,"animations":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }